<template>
  <div :class="skinType == 2 ? 'bg_gray' : 'bg_white'">
    <p class="nothing-tips" v-if="modleDataShow && !list">暂无数据</p>
    <section class="main" v-if="list">
      <!-- 主要股东 -->
      <hgroup class="mainPage gdhs bdgb">
        <!-- <header> -->
        <!-- 主要股东  -->
        <!-- <div :class="zyguShowBtn ? 'btn_show' : 'showNot'" @click="zyguShowBtn = !zyguShowBtn">最终控制人</div> -->
        <!-- </header> -->
        <div class="tab-sub-cont">
          <div class="nav-line">
            <!-- <div class="flex time_box" style="overflow: hidden;width: -webkit-max-content; width: -moz-max-content;width: max-content;"> -->
            <div class="time_box" style="overflow: hidden;">
              <span
                v-for="(item, index) in list.jzrqList"
                :class="zygdNavKey === index ? 'cur' : ''"
                :key="index"
                @click="zygdNavKey = index"
                >{{ item | timeFream }}</span
              >
            </div>
          </div>
          <div class="nav-line-content">
            <table class="table table-col4" width="100%">
              <div class="tr_box">
                <tr>
                  <th>股东名称</th>
                  <th>持股占比</th>
                  <th>持股股数/变动</th>
                </tr>
              </div>
              <div
                class="tr_box"
                v-for="(item, index) in list.data[list.jzrqList[zygdNavKey]]"
                :key="index"
              >
                <tr>
                  <td>{{ item.gdmc }}</td>
                  <td>{{ item.cgzb ? item.cgzb + "%" : item.cgzb }}</td>
                  <td>
                    {{ process(item.cggs) }} /
                    <span :class="item.cgzbbd | zygdColor">{{
                      item.cgzbbd | zygdFilter
                    }}</span>
                  </td>
                </tr>
                <!-- <div v-show="zyguShowBtn" class="final_box">数据库恢复健康sad混分巨兽款到发货时刻绝代风华涉及到开发和圣诞节开放</div> -->
              </div>
            </table>
          </div>
        </div>
      </hgroup>
    </section>
    <Loading v-if="!modleDataShow"></Loading>
    <Declare v-if="modleDataShow && list"></Declare>
  </div>
</template>

<script>
import { getJson } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading";
import Declare from "../components/declare";
export default {
  name: "zygdMore",
  data() {
    return {
      zyguShowBtn: false,
      modleDataShow: false,
      skinType: 2,
      rootStr: "/wap/data/ipad/stock/",
      code: "",
      list: null,
      zygdNavKey: 0,
    };
  },
  components: { Loading, Declare },
  mixins: [mixins],
  created() {
    if (this.getUrlQuery("themeStyleVs") == 2) {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#0c0f13;");
    } else {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#FFF;");
    }
    this.skinType = this.getUrlQuery("themeStyleVs");
    this.code = this.getUrlQuery("code");
    this.$nextTick(function () {
      this.getData();
    });
  },
  methods: {
    // 点击主要股东更多
    getData: function () {
      let code = this.code;
      var url =
        window.config.url +
        this.rootStr +
        this.stockCodeUrl(code) +
        "/f10/gbgd_zygd_more.json";
      getJson(url)
        .then((res) => {
          this.list = res;
          this.modleDataShow = true;
          this.$nextTick(function(){
            this.checkWidth()
          })
        })
        .catch((err) => {
          console.log(err, "err");
          this.modleDataShow = true;
        });
    },
    // 计算宽度
    checkWidth: function () {
      var domList = document.querySelectorAll(".time_box span");
      var ul_w = 0;
      for (var i = 0; i < domList.length; i++) {
        var style = window.getComputedStyle(domList[i]);
        ul_w = ul_w + domList[i].offsetWidth + parseInt(style.marginRight) + 1;
      }

      document.getElementsByClassName("time_box")[0].style.width = ul_w + "px";
    },
  },
};
</script>
<style lang="less">
@import "../assets/css/style2.less";
</style>
<style lang="less" scoped>
.nav-line {
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  span {
    display: inline-block;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }
}
</style>
